import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CommunityAssociation } from ".";

const createCustomFilter = createCustomFilterForEntity<CommunityAssociation>();

export class CommunityAssociationFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CommunityAssociation>
  >((filters) => {
    return filterWithRelationsAndJson(CommunityAssociation)(filters);
  });
}
